/**
 * "Switch to it" from the Versions dialog (W2-10 projects-data; DESIGN.md §5.13).
 *
 * Browsers do not let a page bring another tab to the front, so the tab that wants a chart posts a focus request
 * on the Library's BroadcastChannel; the tab that has the chart open focuses itself, makes its title blink and says
 * why. This is the same message the Library sends ({ kind: 'focus', id } on 'phiedit-library'), answered by the
 * Library module's `init` in every tab: features cannot import each other's files, so the two lines of protocol are
 * repeated here.
 */

import type { ProjectId } from '../../core/model/types';

const CHANNEL = 'phiedit-library';

/** Asks the tab that has `id` open to come forward. False when tabs cannot talk to each other here. */
export function requestTabFocus(id: ProjectId): boolean {
  if (typeof BroadcastChannel !== 'function') return false;
  let ch: BroadcastChannel;
  try {
    ch = new BroadcastChannel(CHANNEL);
  } catch {
    return false;
  }
  try {
    ch.postMessage({ kind: 'focus', id });
    return true;
  } catch {
    return false;
  } finally {
    ch.close();
  }
}
